import { defaultPresets } from "./viewPreset";

/**
 * Scheduler の設定を fiscalStartMonth・fiscalYear に基づいて生成
 * @returns {object} schedulerConfig
 */
export function createSchedulerConfig() {
  return {
    presets: defaultPresets,
    viewPreset: "day",
    rowHeight: 50,
    stripeFeature: true,
    dependenciesFeature: false,
    dependencyEditFeature: false,
    percentBarFeature: false,
    timeRangesFeature: true,
    treeFeature: true,
    zoomOnMouseWheel: false,
    cellTooltipFeature: true,
    filterFeature: false,
    sortFeature: false,
    cellMenuFeature: false,
    timeAxisHeaderMenuFeature: false,
    timeSpanHighlightFeature: true,
    loadMaskError: false,
    zoomOnTimeAxisDoubleClick: false,
  };
}
